module.exports = __webpack_public_path__ + "static/rakuma-2d5ec6913e29bcd3c7f3dd69d712d93b.svg";